export const sealStatus = {
  sealed: 'Sealed',
  awaitingunseal: 'Awaiting Unseal',
  unsealed: 'Unsealed',
}
